import qs from 'qs'
const SUCCESSCODE = 200
const FAILCODE = 500
function createScript(url, handler) {
  const script = document.createElement('script')
  script.src = url
  script.type = 'text/javascript'
  script.async = true
  script.onload = handler
  script.onerror = handler
  document.body.appendChild(script)
  return script
}

export default function jsonpAdapter(config) {
  return new Promise(function dispatchJsonpRequest(resolve, reject) {
    let response = {
      status: 0
    }
    let script = null
    const callback = config.params[config.jsonp]
    let url = config.url
    const paramsStr = qs.stringify(config.params)
    dispatchJsonpRequest.tid && clearTimeout(dispatchJsonpRequest.tid)
    if (url.indexOf('?') > -1) {
      url = `${url}&${paramsStr}`
    } else {
      url = `${url}?${paramsStr}`
    }
    if (config.timeout > 0) {
      dispatchJsonpRequest.tid = setTimeout(() => {
        dispatchJsonpRequest.tid = null
        response = {
          status: FAILCODE,
          statusText: 'request timeout'
        }
        reject(response)
      }, config.timeout)
    }
    if (config.cancelToken) {
      config.cancelToken.promise.then(function(cancel) {
        if (!script || response.status) {
          return
        }
        response = {
          status: FAILCODE,
          statusText: String(cancel)
        }
        reject(response)
      })
    }
    const handler = function (ref) {
      if (response.status) return
      const type = ref.type
      if (type === 'load') {
        response.status = SUCCESSCODE
      } else if (type === 'error') {
        response.status = FAILCODE
      }

      if (response.status && window[callback]) {
        delete window[callback]
        document.body.removeChild(script)
        script = null
        response.status === SUCCESSCODE ? resolve(response) : reject(response)
      }
    }

    window[callback] = function (data) {
      response.data = data
    }
    script = createScript(url, handler)
  })
}
